import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/global/Header";
import LeftNavbar from "../../components/global/LeftNavbar";
import {  useTranslation } from 'react-i18next';
import { getAxiosResponse, postAxiosResponse } from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import { dateConvertToTimeStamp} from "../../services/Util";
import Constants from "../../Constants";
import Select from 'react-select';
import ReactTooltip from "react-tooltip";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import $ from "jquery";
import { Breadcrumb } from "../../components/dashboard/Breadcrumb";

export default function NewUserManagement() {
    const owner = useSelector(
      (loginSessionDetail) => loginSessionDetail.loginSession
    ).value;

    const customerBootstrapData = useSelector(reduxStore => reduxStore.customer_bootstrap_data).value;
    const scrollRef = useRef(null);
    const selectRef = useRef();
    const { t } = useTranslation();
    const translate = t;
    const navigate = useNavigate();

    
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [title, setTitle] = useState("");

    const [roleData, setRoleData] = useState([]);
    const [userRole, setUserRole] = useState([]);
    const [selectedUserRole, updateSelectedUserRole] = useState({label: '', value: ''})
    const [showAdditionalRoleDropdown, setShowAdditionalRoleDropdown] = useState(false);
    const [additionalUserRole, setAdditionalUserRole] = useState([]);
    const [selectedAdditionalUserRole, updateSelectedAdditionalUserRole] = useState({label: '', value: ''});

    const [departments, setDepartments] = useState([]);
    const [totalDepartments, setTotalDepartments] = useState(0);
    const [showDepartments, setShowDepartments] = useState(false);
    const [showAdminDepartments, setShowAdminDepartments] = useState(false);
    const [departmentsForAdministrator, setDepartmentsForAdministrator] = useState([])
    const [allDepartments, setAllDepartments] = useState([]);

    const [updateExistingProjects, setUpdateExistingProjects] = useState(false);

    const [targetLanguage, setTargetLanguage] = useState([]);
    const [selectedTargetLanguageList, updateSelectedTargetLanguageList] = useState([]);
    const [sourceLanguage, setSourceLanguage] = useState([]);
    const [selectedSourceLang, setSelectedSourceLang] = useState([]);
    const [selectedSourceLanguageList, updateSelectedSourceLanguageList] = useState([]);
    const [sourceLanguageForPairing, setSourceLanguageForPairing] = useState([]);
    const [targetLanguageForPairing, setTargetLanguageForPairing] = useState([]);
    const [selectedTargetLanguagePairing, updateSelectedTargetLanguagePairing] = useState([]);
    const [showLanguagePairs, setShowLanguagePairs] = useState(false);
    const [showLanguagesToReview, setShowLanguagesToReview] = useState(true);
    const [showTargetLanguageList, setShowTargetLanguageList] = useState(false);
    const [selectedTarget, setSelectedTarget] = useState("");
    const [displayUserLanguagePairs, setDisplayUserLanguagePairs] = useState([]);

    const [bidAutoApprove, setBidAutoApprove] = useState(false);
    const [seeDirectoryTab, setSeeDirectoryTab] = useState(false);
    const [skipTmUpload, setSkipTmUpload] = useState(false);
    const [bidOutToCloudwordsChosenVendors, setBidOutToCloudwordsChosenVendors] = useState(false);
    const [tmReadEdit, setTmReadEdit] = useState(false);
    const [glossaryRead, setGlossaryRead] = useState(false);
    const [glossaryEdit, setGlossaryEdit] = useState(false);
    const [styleguideReadEdit, setStyleguideReadEdit] = useState(false);
    const [marketo, setMarketo] = useState(false);
    const [marketoRest, setMarketoRest] = useState(false);
    const [brightcove, setBrightcove] = useState(false);
    const [pardot, setPardot] = useState(false);
    const [vidyard, setVidyard] = useState(false);
    const [uberflip, setUberflip] = useState(false);
    const [eloqua, setEloqua] = useState(false);
    const [machineTranslation, setMachineTranslation] = useState(false);
    
    const [eloquaEnabled, setEloquaEnabled] = useState({});
    const [marketoEnabled, setMarketoEnabled] = useState({});
    const [marketoRestEnabled, setMarketoRestEnabled] = useState({});
    const [brightcoveEnabled, setBrightcoveEnabled] = useState({});
    const [vidyardEnabled, setVidyardEnabled] = useState({});
    const [uberflipEnabled, setUberflipEnabled] = useState({});
    const [pardotEnabled, setPardotEnabled] = useState({});
    const [machineTranslationEnabled, setMachineTranslationEnabled] = useState({});
    
    const [availableAsInternalTranslator, setAvailableAsInternalTranslator] = useState(false);
    const [availableAsProjectFollower, setAvailableAsProjectFollower] = useState(false);
    const [automaticallyFollowProjects, setAutomaticallyFollowProjects] = useState(false);
    const [filteredDepartments, setFilteredDepartments] = useState([{label: `${t('select_one_department')}`, value: Constants.BLANK}, {label: `${t('select_all')}`, value: Constants.ALL}]);
    const [showDepartmentDropdown, setShowDepartmentDropdown] = useState(false);
    const [userGroupMemberSettings, updateUserGroupMemberSettings] = useState([]);
    const [userLanguagePairsSettings, updateUserLanguagePairsSettings] = useState([]);
    const [userLanguagesToReview, updateUserLanguagesToReview] = useState([]);
    const [orgDetails, setOrgDetails] = useState({});
    const [features, setFeatures] = useState({});
    const [showRequestingBids, setShowRequestingBids] = useState(true);
    const [showVendorMarketplace, setShowVendorMarketPlace] = useState(true);
    const [showMarketo, setShowMarketo] = useState(true);
    const [showMarketoRest, setShowMarketoRest] = useState(true);
    const [showBrightcove, setShowBrightcove] = useState(true);
    const [showPardot, setShowPardot] = useState(true);
    const [showVidyard, setShowVidyard] = useState(true);
    const [showUberflip, setShowUberflip] = useState(true);
    const [showEloqua, setShowEloqua] = useState(true);
    const [showMachineTranslation, setShowMachineTranslation] = useState(true);
    const [disableSaveButton, setDisableSaveButton] = useState(true);
    const [departmentsAvailable, setDepartmentsAvailable] = useState(false);
    const [showFollowOptions, setShowFollowOptions] = useState(false);
    const [currentRoleTypes, setCurrentRoleTypes] = useState([]);

    const [firstNameError, showFirstNameError] = useState(false);
    const [firstNameErrorMessage, setFirstNameErrorMessage] = useState("");
    const [lastNameError, showLastNameError] = useState(false);
    const [lastNameErrorMessage, setLastNameErrorMessage] = useState("");
    const [emailError, showEmailError] = useState(false);
    const [emailErrorMessage, setEmailErrorMessage] = useState("");
    const [userGroupMembersError, showUserGroupMembersError] = useState(false);
    const [userGroupMembersErrorMessage, setUserGroupMembersErrorMessage] = useState("");
    const [isAdminRole, setIsAdminRole] = useState(false);

    useEffect(() => {
      const dateTimestamp = dateConvertToTimeStamp();
      getAxiosResponse(
        APIUrls.CUSTOMER_ORG_PREFERENCE +
          `?preference=ENABLE_ELOQUA_INTEGRATION&_=${dateTimestamp}`
      ).then((res) => {
        setEloquaEnabled(res.data.data);
      });
      getAxiosResponse(
        APIUrls.CUSTOMER_ORG_PREFERENCE +
          `?preference=ENABLE_MARKETO_INTEGRATION&_=${dateTimestamp}`
      ).then((res) => {
        setMarketoEnabled(res.data.data);
      });
      getAxiosResponse(
        APIUrls.CUSTOMER_ORG_PREFERENCE +
          `?preference=ENABLE_MARKETOREST_INTEGRATION&_=${dateTimestamp}`
      ).then((res) => {
        setMarketoRestEnabled(res.data.data);
      });
      getAxiosResponse(
        APIUrls.CUSTOMER_ORG_PREFERENCE +
          `?preference=ENABLE_BRIGHTCOVE_INTEGRATION&_=${dateTimestamp}`
      ).then((res) => {
        setBrightcoveEnabled(res.data.data);
      });
      getAxiosResponse(
        APIUrls.CUSTOMER_ORG_PREFERENCE +
          `?preference=ENABLE_PARDOT_INTEGRATION&_=${dateTimestamp}`
      ).then((res) => {
        setPardotEnabled(res.data.data);
      });
      getAxiosResponse(
        APIUrls.CUSTOMER_ORG_PREFERENCE +
          `?preference=ENABLE_VIDYARD_INTEGRATION&_=${dateTimestamp}`
      ).then((res) => {
        setVidyardEnabled(res.data.data);
      });
      getAxiosResponse(
        APIUrls.CUSTOMER_ORG_PREFERENCE +
          `?preference=ENABLE_UBERFLIP_INTEGRATION&_=${dateTimestamp}`
      ).then((res) => {
        setUberflipEnabled(res.data.data);
      });
      getAxiosResponse(
        APIUrls.CUSTOMER_ORG_PREFERENCE +
          `?preference=ENABLE_MACHINE_TRANSLATION&_=${dateTimestamp}`
      ).then((res) => {
        setMachineTranslationEnabled(res.data.data);
      });
      getAxiosResponse(APIUrls.USER_ROLES).then((res) => {
        const options = [{ label: `${t('select_one')}`, value: Constants.BLANK }];
        res.data.data.map((role) =>
          options.push({
            label: role.displayName,
            value: role.value,
          })
        );
        setUserRole(options);
        setRoleData(res.data.data);
      });
      getAxiosResponse(
        APIUrls.SOURCE_LANGUAGE
      ).then((res) => {
        const options = [];
        res.data.data.map((language) =>
          options.push({
            label: language.display,
            value: language.code,
            displayLang : language.language
          })
        );
        setSourceLanguage(options);
        setSourceLanguageForPairing(options);
      });
      getAxiosResponse(
        APIUrls.TARGET_LANGUAGE
      ).then((res) => {
        const options = [{ label: `${t('select_language')}`, value: Constants.BLANK }, {label: `${t('select_all')}`, value: Constants.ALL}];
        res.data.data.map((language) =>
          options.push({
            label: language.display,
            value: language.code,
            displayLang: language.language
          })
        );
        setTargetLanguage(options);
        const targetPairing = [];
        res.data.data.map((lang) =>
          targetPairing.push({
            label: lang.display,
            value: lang.code,
            displayLang: lang.language
          })
        );
        setTargetLanguageForPairing(targetPairing);
      });
      if(customerBootstrapData?.features?.ROLES) {
        let option = {value: ""};
        setCurrentRoleTypes([option]);
      } else {
        let option = {value : customerBootstrapData?.roleSet};
        setCurrentRoleTypes([option]);
      }
      handleDepartments();
      getAxiosResponse(APIUrls.CUSTOMER_BOOTSTRAP_DATA)
      .then((res) => {
        setOrgDetails(res.data.data.organization);
        setFeatures(res.data.data.features);
      })
    }, []);

    useEffect(() => {
        updateUserGroupSettings(departments)
    }, [departments])

    const updateUserGroupSettings = (depts) => {
        if (customerBootstrapData?.features?.ROLES) {
            const hasNonSystemGroup = depts.find((department) => department.value !== customerBootstrapData?.systemUserGroup?.id);
            const newGroups = hasNonSystemGroup
                ? depts.map((dept) => ({
                    defaultFollowAllProjects: false,
                    includeInFollowersList: true,
                    availableAsInternalTranslator: false,
                    userGroup: {
                      id: dept.value,
                      name: dept.label,
                    },
                  }))
                : [
                    {
                      includeInFollowersList: true,
                      defaultFollowAllProjects: false,
                      availableAsInternalTranslator: false,
                      userGroup: { id: customerBootstrapData?.systemUserGroup?.id },
                    },
                  ];
      
              updateUserGroupMemberSettings(newGroups);
            } else {
              const options2 = depts.map((dept) => ({
                defaultFollowAllProjects: false,
                includeInFollowersList: true,
                availableAsInternalTranslator: false,
                userGroup: {
                  id: dept.value,
                  name: dept.label,
                },
              }));

            updateUserGroupMemberSettings(options2);
        }

    }

    const handleDepartments = () => {
      if (customerBootstrapData?.features?.USER_GROUPS) {
        getAxiosResponse(APIUrls.DEPARTMENT_URL)
          .then((res) => {
            const options = res.data.data.map((dept) => ({
              label: dept.name,
              value: dept.id,
            }));
      
            setDepartments(options);
            setDepartmentsForAdministrator(options);
            setTotalDepartments(options.length);
            setAllDepartments(options);

            updateUserGroupSettings(options);

            setDepartmentsAvailable(options.length > 0);
            if (!options.length) {
              addSystemGroupToDepartmentCollection();
            }
          });
      } else {
        setDepartmentsAvailable(false);
        addSystemGroupToDepartmentCollection();
      
        const option = [{
          includeInFollowersList: true,
          defaultFollowAllProjects: false,
          availableAsInternalTranslator: false,
          userGroup: { id: customerBootstrapData?.systemUserGroup?.id },
        }];
      
        updateUserGroupMemberSettings(option);
      }
    }

    const addSystemGroupToDepartmentCollection = () => {
      let systemGroupId = customerBootstrapData?.systemUserGroup?.id;
      let systemGroup = {"label":"","value":systemGroupId};
      setDepartments([systemGroup]);
    }

    const configureShowFollowOptions = () => {
      if(currentRoleTypes) {
        if((currentRoleTypes?.length === 1) && (currentRoleTypes[0] === "ROLE_CUSTOMER_PROJECT_REQUESTER" || currentRoleTypes[0].value === "ROLE_CUSTOMER_PROJECT_REQUESTER")) {
          setShowFollowOptions(false);
        } 
        setShowFollowOptions(true);
      }
    }

    useEffect(() => {
      configureShowFollowOptions();
    }, [currentRoleTypes]);

    useEffect(() => {
      filteredDepartments.length > 2 && !showAdminDepartments ? setShowDepartmentDropdown(true) : setShowDepartmentDropdown(false);
      if(filteredDepartments.length === totalDepartments+2) {
        selectedUserRole.value === Constants.ROLE_CUSTOMER_ADMIN || selectedAdditionalUserRole.value === Constants.ROLE_CUSTOMER_ADMIN ? setShowAdminDepartments(false) : setShowDepartments(false);
      } else {
        selectedUserRole.value === Constants.ROLE_CUSTOMER_ADMIN || selectedAdditionalUserRole.value === Constants.ROLE_CUSTOMER_ADMIN ? setShowAdminDepartments(true) : setShowDepartments(true);
      }
    }, [filteredDepartments, selectedUserRole, selectedAdditionalUserRole])

    useEffect(() => {
      $(".body").on('click', function(){
        if($('.popover-body').hasClass('show-assignee-dropdown')) {
          setShowTargetLanguageList("");
        }
      })
    }, [displayUserLanguagePairs])

    useEffect(() => {
        setUserLanguagesPayload();
    }, [selectedTargetLanguageList])

    useEffect(() => {
        checkAdditionalRoles();
        setPermissionsBasedOnRole();
    }, [selectedUserRole])

    useEffect(() => {
        setPermissionsBasedOnRole();
    }, [selectedAdditionalUserRole])

    useEffect(() => {
      if(firstName === Constants.BLANK || lastName === Constants.BLANK || email === Constants.BLANK || selectedUserRole.value === Constants.BLANK ) {
        setDisableSaveButton(true);
      } else {
        setDisableSaveButton(false);
      }
    }, [firstName, lastName, email, selectedUserRole, userGroupMemberSettings])
      useEffect(()=>{
        $(".lastdisable").trigger("focus");
      }, [])

    const setUserLanguagesPayload = () => {
        let options = selectedTargetLanguageList.map((targetLang) => ({
            language : targetLang.displayLang
        }));
        updateUserLanguagesToReview(options);
    }

    const updateUserRole = (value) => {
        updateSelectedUserRole(value);
        updatePermissions(value.value);
        setAvailableAsInternalTranslator(false);
        setShowLanguagePairs(false);
        setShowLanguagesToReview(true);
        setAvailableAsProjectFollower(false);
        setAutomaticallyFollowProjects(false);
        if(value.value === Constants.ROLE_CUSTOMER_ADMIN) {
            setIsAdminRole(true);
            handleDepartments();
            setShowAdminDepartments(true);
            setShowDepartments(false);
            setFilteredDepartments([
          { label: `${t('select_one_department')}`, value: Constants.BLANK },
          { label: `${t('select_all')}`, value: Constants.ALL },
          ]);
        } else {
            setDepartments([]);
            setIsAdminRole(false);
            setShowDepartments(true);
            setAvailableAsProjectFollower(true);
            setAutomaticallyFollowProjects(true);
            setShowAdminDepartments(false);
            if(value.value === Constants.ROLE_INTERNAL_TRANSLATOR) {
                setAvailableAsInternalTranslator(true);
                setShowLanguagePairs(true);
                setShowLanguagesToReview(false);
            }
            if(value.value === Constants.ROLE_PROJECT_REQUESTER) {
                setAvailableAsProjectFollower(false);
                setAutomaticallyFollowProjects(false);
                setAvailableAsInternalTranslator(false);
                setShowLanguagesToReview(false);
            }
            if(value.value === Constants.ROLE_QUOTE_APPROVER) {
                setShowLanguagesToReview(false);
              }
          setFilteredDepartments([
          { label: `${t('select_one_department')}`, value: Constants.BLANK },
          { label: `${t('select_all')}`, value: Constants.ALL },
          ...allDepartments
        ]);
        }
        if(departmentsAvailable) {
          setDepartmentsForAdministrator(allDepartments);
        }
    }

    const updatePermissions = (roleValue) => {
        if(roleValue === Constants.ROLE_CUSTOMER_ADMIN) {
            features.AUTO_APPROVE_BID ? setBidAutoApprove(true) : setBidAutoApprove(false);
            features.ALTER_TM_UPLOAD_REQUIREMENT ? setSkipTmUpload(true) : setSkipTmUpload(false);
            !features.WHITE_LABEL_VENDOR_EXCLUSIVE ? setSeeDirectoryTab(true) : setSeeDirectoryTab(false);
            !features.WHITE_LABEL_VENDOR_EXCLUSIVE ? setBidOutToCloudwordsChosenVendors(true) : setBidOutToCloudwordsChosenVendors(false);
            features.TM_BROWSE_AND_EDIT ? setTmReadEdit(true) : setTmReadEdit(false);
            setGlossaryRead(true);
            setGlossaryEdit(true);
            setStyleguideReadEdit(false);
        }
        if(roleValue === Constants.ROLE_PROJECT_MANAGER) {
            setBidAutoApprove(true);
            setSeeDirectoryTab(true);
            setBidOutToCloudwordsChosenVendors(true);
            setTmReadEdit(false);
            setGlossaryRead(true);
            setGlossaryEdit(true);
            setStyleguideReadEdit(false);
        }
        if(roleValue === Constants.ROLE_QUOTE_APPROVER) {
            setBidAutoApprove(false);
            setSeeDirectoryTab(false);
            setBidOutToCloudwordsChosenVendors(false);
            setTmReadEdit(false);
            setGlossaryRead(false);
            setGlossaryEdit(false);
            setStyleguideReadEdit(false);
        }
        if(roleValue === Constants.ROLE_INTERNAL_TRANSLATOR || roleValue === Constants.ROLE_REVIEWER || roleValue === Constants.ROLE_PROJECT_REQUESTER) {
            setBidAutoApprove(false);
            setSeeDirectoryTab(false);
            setBidOutToCloudwordsChosenVendors(false);
            setTmReadEdit(false);
            setGlossaryRead(false);
            setGlossaryEdit(false);
            setStyleguideReadEdit(false);
        }
    }

    const checkAdditionalRoles = () => {
        let additionalRoles = [{ label: `${t('word_none')}`, value: Constants.BLANK }];
        roleData.map((role) => {
            if(role.value === selectedUserRole.value) {
                setShowAdditionalRoleDropdown(false);
                if(role.availableWithInternalTranslator) {
                    let extra = roleData.filter(data => data.value === Constants.ROLE_INTERNAL_TRANSLATOR)[0]
                    if(extra !== undefined) {
                      additionalRoles.push({label: extra.displayName, value: extra.value});
                      setShowAdditionalRoleDropdown(true);
                    }
                }
                if(role.availableWithAdmin) {
                    let extra = roleData.filter(data => data.value === Constants.ROLE_CUSTOMER_ADMIN)[0]
                    if(extra !== undefined) {
                      additionalRoles.push({label: extra.displayName, value: extra.value});
                      setShowAdditionalRoleDropdown(true);
                    }
                }
                if(role.availableWithProjectManager) {
                    let extra = roleData.filter(data => data.value === Constants.ROLE_PROJECT_MANAGER)[0]
                    if(extra !== undefined) {
                      additionalRoles.push({label: extra.displayName, value: extra.value});
                      setShowAdditionalRoleDropdown(true);
                    }
                }
                if(role.availableWithQuoteApprover) {
                    let extra = roleData.filter(data => data.value === Constants.ROLE_QUOTE_APPROVER)[0]
                    if(extra !== undefined) {
                      additionalRoles.push({label: extra.displayName, value: extra.value});
                      setShowAdditionalRoleDropdown(true);
                    }
                }
                if(role.availableWithRequester) {
                    let extra = roleData.filter(data => data.value === Constants.ROLE_PROJECT_REQUESTER)[0]
                    if(extra !== undefined) {
                      additionalRoles.push({label: extra.displayName, value: extra.value});
                      setShowAdditionalRoleDropdown(true);
                    }
                }
                if(role.availableWithReviewer) {
                    let extra = roleData.filter(data => data.value === Constants.ROLE_REVIEWER)[0]
                    if(extra !== undefined) {
                      additionalRoles.push({label: extra.displayName, value: extra.value});
                      setShowAdditionalRoleDropdown(true);
                    }
                }
            }
        })
        if(selectedUserRole.value === Constants.BLANK) {
            setShowAdditionalRoleDropdown(false);
        }
        setAdditionalUserRole(additionalRoles);
        updateSelectedAdditionalUserRole({ label: `${t('word_none')}`, value: Constants.BLANK })
    }

    const handleAdditionalRoleChange = (value) => {
        updateSelectedAdditionalUserRole(value);
        if(value.value === Constants.ROLE_INTERNAL_TRANSLATOR) {
            setShowLanguagePairs(true);
            setAvailableAsInternalTranslator(true);
        }
         else if(value.value === Constants.ROLE_CUSTOMER_ADMIN) {
            setShowAdminDepartments(true);
            setShowDepartments(false);
            setFilteredDepartments([
          { label: `${t('select_one_department')}`, value: Constants.BLANK },
          { label: `${t('select_all')}`, value: Constants.ALL },
          ]);
          handleDepartments();
        }
         else {
            if(selectedUserRole.value === Constants.ROLE_INTERNAL_TRANSLATOR) {
                setShowLanguagePairs(true);
                if (value.value === Constants.ROLE_CUSTOMER_ADMIN) {
                  setShowAdminDepartments(true);
                  setShowDepartments(false);
                } else {
                  setShowAdminDepartments(false);
                  setShowDepartments(true);
                }
                if (value.value !== Constants.BLANK) {
                  setShowLanguagesToReview(true);
                } else setShowLanguagesToReview(false);
            } else {
                setShowLanguagePairs(false);
                value.value === Constants.ROLE_INTERNAL_TRANSLATOR ? setAvailableAsInternalTranslator(true) : setAvailableAsInternalTranslator(false);
                setShowLanguagesToReview(true);
                if(selectedUserRole.value === Constants.ROLE_PROJECT_REQUESTER) {
                    if(value.value === Constants.ROLE_REVIEWER) {
                        setAvailableAsProjectFollower(true);
                        setAutomaticallyFollowProjects(true);
                        setAvailableAsInternalTranslator(false);
                    } else {
                        setAvailableAsProjectFollower(false);
                        setAutomaticallyFollowProjects(false);
                        setShowLanguagesToReview(false);
                    }
                }
            };
            
        }
    }

    const updateSourceLanguage = (value) => {
      if (value.value !== Constants.BLANK) {
        let option = sourceLanguage.find((lang) => lang.value === value.value);
        option.disabled = true;
        setSourceLanguage(sourceLanguage);
        setSelectedSourceLang(value);
        updateSelectedSourceLanguageList((selectedSourceLanguageList) => [
          ...selectedSourceLanguageList,
          value,
        ]);
      }
    };

    const updateTargetLang = (value) => {
        if (value.value === Constants.ALL) {
          updateSelectedTargetLanguageList((selectedTargetLanguageList) => [...selectedTargetLanguageList, ...targetLanguage.filter((lang) => lang.value !== Constants.BLANK && lang.value !== Constants.ALL)]);
          setTargetLanguage([
            { label: `${t('select_language')}`, value: Constants.BLANK },
            { label: `${t('select_all')}`, value: Constants.ALL},
          ]);
        } else {
          if(value.value !== Constants.BLANK) {
            setTargetLanguage(
              targetLanguage.filter((lang) => lang.value !== value.value)
            );
            updateSelectedTargetLanguageList((selectedTargetLanguageList) => [
              ...selectedTargetLanguageList,
              value,
            ]);
          }
        }
    }

    const updateSelectedDepartment = (value) => {
        if(value.value === Constants.ALL) {
            setDepartments([]);
            setDepartments((departments) => [...departments, ...departmentsForAdministrator.filter((dept) => dept.value !== Constants.BLANK && dept.value !== Constants.ALL)]);
            setFilteredDepartments([
              { label: `${t('select_one_department')}`, value: Constants.BLANK },
              { label: `${t('select_all')}`, value: Constants.ALL },
            ]);
        } else {
            if(value.value !== Constants.BLANK) {
              if(filteredDepartments.length === totalDepartments + 2) {
                setDepartments([]);
              }
              setDepartments((departments) => [
                ...departments,
                ...filteredDepartments.filter((dept) => dept.value === value.value)
              ]);
                setFilteredDepartments(
                  filteredDepartments.filter((dept) => dept.value !== value.value)
                );
            }
        }
    }

    const clearTargetLanguage = (language) => {
      updateSelectedTargetLanguageList(
        selectedTargetLanguageList.filter((lang) => lang.value !== language.value)
      );
      setTargetLanguage((targetLang) => [...targetLang, language]);

   
      const selectedElement = $(document.activeElement).closest(".multiselect-output");
      if($(document.activeElement).is(':last-child') &&
        selectedElement.children().length > 1){
          selectedElement.find('button:nth-last-child(2)').trigger('focus');
      } else if($(document.activeElement).is(':last-child')){
        $(document.activeElement).closest(".lang-and-review").find('.wrap-dropdown input:first-of-type').trigger('focus');
      }

    };

    const clearTargetLanguageOnKeydown = (event, language) => {
      if (event.key === Constants.ENTER) {
        clearTargetLanguage(language);
      }
    };

    const clearDepartment = (deptId) => {
        setDepartments(departments.filter((department) => department.value !== deptId));
        let filteredDept = departments.filter((department) => department.value === deptId);
        let options = filteredDept.map((dept) => ({
            label: dept.label,
            value: dept.value
        }))
        setFilteredDepartments((filteredDepartments) => [...filteredDepartments, ...options]);

        $('.multiselect-output button').on('click', function(){
          if($(document.activeElement).closest('table').children().length === 2){
            $(document.activeElement).closest('.profile-department').find(':input:first').trigger('focus');
          } else if($(document.activeElement).closest('tr').is(':last-child')){
            $(document.activeElement).closest('tr').prev().find('td:first button:first').trigger('focus');
          }
      })
    }

    const clearDepartmentOnKeyDown = (event, deptId) => {
        if (event.key === Constants.ENTER) {
          clearDepartment(deptId);
        }
    }

    const handleDepartmentChecks = (e, deptId) => {
        let settingsToBeUpdated = userGroupMemberSettings.filter((groupMember) => groupMember.userGroup.id === deptId);
        if(e.target.id.includes("available-as-project-follower")) {
            settingsToBeUpdated[0].includeInFollowersList = e.target.checked;
        }
        if(e.target.id.includes("automatically-follow-projects")) {
            settingsToBeUpdated[0].defaultFollowAllProjects = e.target.checked;
        }
        if(e.target.id.includes("available-as-internal-translator")) {
            settingsToBeUpdated[0].availableAsInternalTranslator = e.target.checked;
        }

        userGroupMemberSettings.map((groupMember) => {
            if(groupMember.userGroup.id === deptId) {
                groupMember = settingsToBeUpdated[0];
            }
        })
    }

    const setPermissionsBasedOnRole = () => {
        if(selectedUserRole.value !== Constants.ROLE_INTERNAL_TRANSLATOR && selectedUserRole.value !== Constants.ROLE_REVIEWER 
        && selectedUserRole.value !== Constants.ROLE_PROJECT_REQUESTER) {
            setShowRequestingBids(true);
            setShowVendorMarketPlace(true);
            if(selectedUserRole.value !== Constants.ROLE_QUOTE_APPROVER) {
                setShowMarketo(true);
                setShowMarketoRest(true);
                setShowBrightcove(true);
                setShowPardot(true);
                setShowVidyard(true);
                setShowUberflip(true);
                setShowEloqua(true);
                setShowMachineTranslation(true);
            } else {
                setShowMarketo(false); 
                setShowMarketoRest(false);
                setShowBrightcove(false);
                setShowPardot(false);
                setShowVidyard(false);
                setShowUberflip(false);
                setShowEloqua(false);
                setShowMachineTranslation(false);
            }
        } else {
            setShowRequestingBids(false);
            setShowVendorMarketPlace(false);
            if(selectedAdditionalUserRole.value === Constants.ROLE_CUSTOMER_ADMIN || selectedAdditionalUserRole.value === Constants.ROLE_PROJECT_MANAGER) {
                setShowRequestingBids(true);
                setShowVendorMarketPlace(true);
                setShowMarketo(true);
                setShowMarketoRest(true);
                setShowBrightcove(true); 
                setShowPardot(true);
                setShowVidyard(true);
                setShowUberflip(true);
                setShowEloqua(true);
                setShowMachineTranslation(true);
            } else {
                setShowMarketo(false); 
                setShowMarketoRest(false);
                setShowBrightcove(false)
                setShowPardot(false);
                setShowVidyard(false);
                setShowUberflip(false);
                setShowEloqua(false);
                setShowMachineTranslation(false);
            }
        }
    }

    const handleUserMemberGroupSettings = () => {
      userGroupMemberSettings.map((setting) => {
        setting.includeInFollowersList = (selectedUserRole?.value === Constants.ROLE_PROJECT_REQUESTER 
          && selectedAdditionalUserRole?.value === Constants.BLANK) ? false : true;
      })
    }

    const createUser = () => {
        handleUserMemberGroupSettings();
        let data = {
            email : email,
            firstName: firstName,
            lastName: lastName,
            title: title,
            permissions: {
                "BID_AUTO_APPROVAL" : bidAutoApprove,
                "SEE_DIRECTORY_TAB" : seeDirectoryTab,
                "BID_OUT_TO_CW_CHOSEN_VENDORS" : bidOutToCloudwordsChosenVendors,
                "TM_READ_EDIT": tmReadEdit,
                "GLOSSARY_READ" : glossaryRead,
                "GLOSSARY_EDIT" : glossaryEdit,
                "STYLEGUIDE_READ_EDIT" : styleguideReadEdit,
                "MARKETO_ACCESS" : Boolean(marketoEnabled.status) && marketo,
                "MARKETOREST_ACCESS" : Boolean(marketoRestEnabled.status) && marketoRest,
                "BRIGHTCOVE_ACCESS" : Boolean(brightcoveEnabled.status) && brightcove,
                "PARDOT_ACCESS" : Boolean(pardotEnabled.status) && pardot,
                "VIDYARD_ACCESS" : Boolean(vidyardEnabled.status) && vidyard,
                "UBERFLIP_ACCESS" : Boolean(uberflipEnabled.status) && uberflip,
                "ELOQUA_ACCESS" : Boolean(eloquaEnabled.status) && eloqua,
                "MACHINE_TRANSLATION_ACCESS" : Boolean(machineTranslationEnabled.status) && machineTranslation
            },
            roleSet: {
                roleTypes: selectedAdditionalUserRole.value !== "" ? [selectedUserRole.value, selectedAdditionalUserRole.value] : [selectedUserRole.value],
                value: selectedUserRole.value
            },
            updateExistingProjects: updateExistingProjects,
            userGroupForMigration: null,
            userGroupForRequestMigration: null,
            userGroupMembers: userGroupMemberSettings
        }
        if(userLanguagesToReview.length !== 0) {
          data['userLanguages'] = userLanguagesToReview;
        } 
        if(userLanguagePairsSettings.length !== 0) {
          data['userLanguagePairs'] = userLanguagePairsSettings;
        }
        postAxiosResponse(APIUrls.CREATE_USER, data)
        .then((res) => {
            if(res.data.data.statusCodeValue === 200) {
                navigateBackToUserList(res?.data?.data?.body?.userId);
            }
            if(res.data.data.statusCodeValue === 400) {
              let apiErrors = res.data.data.body.errors;
              Object.keys(apiErrors).map((errorKey) => {
                if(errorKey === Constants.FIRST_NAME) {
                  showFirstNameError(true);
                  setFirstNameErrorMessage(apiErrors[errorKey]);
                 
                }
                if(errorKey === Constants.LAST_NAME) {
                  showLastNameError(true)
                  setLastNameErrorMessage(apiErrors[errorKey]);
                }
                if(errorKey === Constants.USER_EMAIL_FILTER) {
                  showEmailError(true);
                  setEmailErrorMessage(apiErrors[errorKey]);
                  $('#email').trigger('focus')
                }
                if(errorKey === "userGroupMembers") {
                  showUserGroupMembersError(true);
                  setUserGroupMembersErrorMessage(apiErrors[errorKey]);
                }
              })
            }
        })
    }

    const createUserOnKeyDown = (e) => {
        if(e.key === Constants.ENTER) {
            createUser();
        }
    }

    const cancelUserCreation = () => {
      navigate("/settings/user-management");
      $("#new-user").trigger("focus");
    }

    const navigateBackToUserList = (id) => {
        navigate("/settings/my-account-profile/"+id);
    }

    const navigateBackToUserListOnKeyDown = (e) => {
        if(e.key === Constants.ENTER) {
          navigate("/settings/user-management");
        }
    }

    const cancelUserCreationOnKeyDown = (e) => {
        if(e.key === Constants.ENTER) {
          navigate("/settings/user-management");
          $("#new-user").trigger("focus");
        }
    }

    const updateSourceLanguageAndToggleTargetDropdown = (value) => {
      updateSourceLanguage(value);
      if (value.value !== Constants.BLANK) {
        setTargetLanguageForPairing(
          targetLanguage.filter((lang) => lang.value !== value.value && lang.label !== "--Select Language--" && lang.label !== "--Select All--")
        );
      }
      let sourcePair = {
        customerId: orgDetails.id,
        source: value.displayLang,
        target: null,
        userId: owner.id
      }
      updateUserLanguagePairsSettings((userLanguagePairsSettings) => [...userLanguagePairsSettings, sourcePair]);
      var newPair = { source: value, target: [] };
      setDisplayUserLanguagePairs((displayUserLanguagePairs) => [...displayUserLanguagePairs, newPair]);
    }

    const showTargetAssigneeListAndClearSelection = (index, languagePair) => {
      var result = [];
      var resultSource = []
      result = targetLanguage.filter(
        (lang) => !languagePair.target.some((id2) => id2 === lang.label)
      );
      resultSource = result.filter(function (res) {
        return res.value !== languagePair.source.value && res.label !== "--Select Language--" && res.label !== "--Select All--";
      })
      setTargetLanguageForPairing(resultSource);

      setShowTargetLanguageList(index);
      setSelectedTarget("");
      if (selectRef.current) {
        selectRef.current.focus();
      }
    }

    const setTargetLanguageForSource = (value, source) => {
      setSelectedTarget({
        selectedOption: value
      })
      let selectedTargets = userLanguagePairsSettings.map((pair) => {
        if(pair.source === source) return pair.target});

      let selectedSources = userLanguagePairsSettings.map((pair) => pair.source);

      if (value.value !== Constants.BLANK) {
        setTargetLanguageForPairing(
          targetLanguage.filter((lang) => {
            return lang.label !== value.label && !selectedTargets.includes(lang.displayLang) 
            && !selectedSources.includes(lang.displayLang) && lang.label !== "--Select Language--" && lang.label !== "--Select All--"
          })
        );
      }

      let languagePair = {
        customerId: orgDetails.id,
        source: source,
        target: value.displayLang,
        userId: owner.id
      }
      setShowTargetLanguageList("");
      updateUserLanguagePairsSettings((userLanguagePairsSettings) => [...userLanguagePairsSettings, languagePair]);
      var index = displayUserLanguagePairs.findIndex(
        (x) => x.source.displayLang === source
      );
      var copy = displayUserLanguagePairs;
      copy[index].target.push(value.label);
      setDisplayUserLanguagePairs(copy);
    }

    const removeLanguagePairSource = (pair) => {
        updateUserLanguagePairsSettings((current) =>
          current.filter((userLangPair) => userLangPair.source !== pair.source.displayLang)
        );
        var displayValue = pair.source.label
        setSourceLanguage((current) => {
            let option = current.find((option) => option.label === displayValue);
            if(option) {
                option.disabled = false;
            }
            return current;
        });
        setDisplayUserLanguagePairs(displayUserLanguagePairs.filter(pair => pair.source.label !== displayValue));
    }

    const removeLanguagePairTarget = (pair, target) => {
      updateUserLanguagePairsSettings((current) =>
        current.filter((userLangPair) => userLangPair.target !== target)
      );
      var filter = targetLanguage.filter(
        (trgLang) => trgLang.label === target
      )[0];
      setTargetLanguageForPairing((current) => [...current, filter]);
      var index = displayUserLanguagePairs.findIndex(
        (x) => x.source === pair.source
      );
      displayUserLanguagePairs[index].target = displayUserLanguagePairs[index].target.filter((trg) => trg !== target);
    }
  
    const getDepartmentIcon = (dept) => {
      if(showAdminDepartments) {
        return dept.label;
      } else {
        return (
            <div className="multiselect-output flex">
              <button 
              onClick={(e) => clearDepartment(dept.value)}
              onKeyDown={(e) => clearDepartmentOnKeyDown(dept.value)}
              >
                <strong>{dept.label}</strong>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="9"
                  viewBox="0 0 10 9"
                  fill="none"
                >
                  <path
                    d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067"
                    stroke="#213248"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </button>
            </div>
          );
      }
    }

    const validateAndSetFirstName = (value) => {
      setFirstName(value);
      showFirstNameError(false);
      setFirstNameErrorMessage(Constants.BLANK);
    }

    const validateAndSetLastName = (value) => {
      setLastName(value);
      showLastNameError(false);
      setLastNameErrorMessage(Constants.BLANK);
    }

    const validateAndSetEmail = (value) => {
      setEmail(value);
      showEmailError(false);
      setEmailErrorMessage(Constants.BLANK);
    }

    const handleAvailableAsProjectFollower = () => {
      let isChecked = false;
      let allChecked = 0;
      userGroupMemberSettings.map((memberSettigns) => {
        if($("#"+memberSettigns.userGroup.id+"-available-as-project-follower").is(':checked')) {
          isChecked = true;
          allChecked += 1;
        } else {
          isChecked = false;
        }
      })
      userGroupMemberSettings.map((memberSettigns) => {
        if(isChecked && allChecked !== userGroupMemberSettings.length) {
          memberSettigns.defaultFollowAllProjects = isChecked;
          $("#"+memberSettigns.userGroup.id+"-available-as-project-follower").prop("checked", isChecked);
        } else {
          memberSettigns.defaultFollowAllProjects = !isChecked;
          $("#"+memberSettigns.userGroup.id+"-available-as-project-follower").prop("checked", !isChecked);
        }
      })
    }

    const handleAutomaticallyFollowProjects = () => {
      let isChecked = false;
      let allChecked = 0;
      userGroupMemberSettings.map((memberSettigns) => {
        if($("#"+memberSettigns.userGroup.id+"-automatically-follow-projects").is(':checked')) {
          isChecked = true;
          allChecked += 1;
        } else {
          isChecked = false;
        }
      })
      userGroupMemberSettings.map((memberSettigns) => {
        if(isChecked && allChecked !== userGroupMemberSettings.length) {
          memberSettigns.defaultFollowAllProjects = isChecked;
          $("#"+memberSettigns.userGroup.id+"-automatically-follow-projects").prop("checked", isChecked);
        } else {
          memberSettigns.defaultFollowAllProjects = !isChecked;
          $("#"+memberSettigns.userGroup.id+"-automatically-follow-projects").prop("checked", !isChecked);
        }
      })
    }

    const handleAvailableAsInternalTranslator = () => {
      let isChecked = false;
      let allChecked = 0;
      userGroupMemberSettings.map((memberSettigns) => {
        if($("#"+memberSettigns.userGroup.id+"-available-as-internal-translator").is(':checked')) {
          isChecked = true;
          allChecked += 1;
        } else {
          isChecked = false;
        }
      })
      userGroupMemberSettings.map((memberSettigns) => {
        if(isChecked && allChecked !== userGroupMemberSettings.length) {
          memberSettigns.availableAsInternalTranslator = isChecked;
          $("#"+memberSettigns.userGroup.id+"-available-as-internal-translator").prop("checked", isChecked);
        } else {
          memberSettigns.availableAsInternalTranslator = !isChecked;
          $("#"+memberSettigns.userGroup.id+"-available-as-internal-translator").prop("checked", !isChecked);
        }
      })
    }
    const [refs, setRefs] = useState({});
      const departmentTooltipRef = useRef(null);
      $('.profile-department p').on('keydown', function(e){
        if(e.key === Constants.ESCAPE){
        if ($(this).attr('id') === "departmentTooltip") {
          setRefs(departmentTooltipRef);
        }
        }
 	  });
	useEffect(()=>{
		if (refs.current) {
		   refs.current.hideTooltip();
		   setRefs({});
		 }
	 }, [refs]);

    const crumbs = [
      {label:'Settings', url:'settings'},
      {label:'User Management', url:'settings/user-management'},
      {label:'New User', url:''},
     ]; 
  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef} tabIndex={0}>
          <div id="content" className="dashboard-wrap">
            <Breadcrumb crumbs={ crumbs } />
            <div className="my-account-page new-user-management-page">
              <div className="project-heading userprofile-heading">
                <div className="back-arrow flex-center">
                  <button aria-label="Back to User Management" onClick={() => cancelUserCreation()} onKeyDown={(e) => navigateBackToUserListOnKeyDown(e)}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="13"
                      viewBox="0 0 14 13"
                      fill="none"
                    >
                      <path
                        d="M0.46967 5.96967C0.176777 6.26256 0.176777 6.73744 0.46967 7.03033L5.24264 11.8033C5.53553 12.0962 6.01041 12.0962 6.3033 11.8033C6.59619 11.5104 6.59619 11.0355 6.3033 10.7426L2.06066 6.5L6.3033 2.25736C6.59619 1.96447 6.59619 1.48959 6.3033 1.1967C6.01041 0.903806 5.53553 0.903806 5.24264 1.1967L0.46967 5.96967ZM1 7.25H14V5.75H1V7.25Z"
                        fill="#1D4ED8"
                      />
                    </svg>
                    
                  </button>
                  <span>{translate("user_management.back_user_management")}</span>
                </div>
                <h3>{translate("user_management.new_user")}</h3>
                <span>{ translate ("user_management.new_user_cloudwords")}</span>
              </div>
              <div className="white-bg">
                <div className="profile-editonly-block">
                  <div className="profile-edit-form mar-bot14">
                    <div className="flex wrap-dropdown">
                      <div className="global-dropdown-block flex-center">
                        <label>{translate("user_management.first_name")}</label>
                        <input
                          type="text"
                          className="form-control-sm"
                          id="firstName"
                          title="First Name"
                          required
                          onChange={(e) => validateAndSetFirstName(e.target.value)}
                        />
                        <div className={ "error upload-error" + (firstNameError === true ? " show" : " hide")}>
                          {firstNameErrorMessage}
                        </div>
                      </div>
                    <div className="global-dropdown-block flex-center">
                        <label>{translate("user_management.last_name")}</label>
                        <input
                          type="text"
                          className="form-control-sm"
                          id="lastName"
                          title="Last Name"
                          required
                          onChange={(e) => validateAndSetLastName(e.target.value)}
                        />
                        <div className={ "error upload-error" + (lastNameError === true ? " show" : " hide")}>
                          {lastNameErrorMessage}
                        </div>
                      </div>
                    </div>
                    <div className="flex wrap-dropdown">
                      <div className="global-dropdown-block flex-center">
                        <label>{translate("user_management.email")}</label>
                        <input
                          type="text"
                          className="form-control-sm"
                          id="email"
                          title="Email"
                          required
                          onChange={(e) => validateAndSetEmail(e.target.value)}
                          aria-describedby="error-message"
                        />
                        <div className={ "error upload-error" + (emailError === true ? " show" : " hide")} id='error-message'>
                          {emailErrorMessage} 
                        </div>
                      </div>
                      <div className="global-dropdown-block flex-center">
                        <label htmlFor="title">
                        {translate("user_management.title")} <span>{translate("user_management.optional")}</span>
                        </label>
                        <input
                          type="text"
                          className="form-control-sm"
                          title="Title"
                          id="title"
                          onChange={(e) => setTitle(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="role-and-department">
                    <h5 className="heading-width-border">
                    {translate("my_account.role_languages_departments")}                      

                 </h5>
                    <div className="profile-edit-form">
                      <div className="flex wrap-dropdown">
                        <div className="global-dropdown-block flex-center">
                          <label>
                            Role{" "}
                            <span>
                              <a
                                href="https://cloudwords.zendesk.com/hc/en-us/articles/206359183-What-Are-The-Roles-Available-on-Cloudwords-Accounts"
                                target="_blank"
                              >
                         {translate("user_management.learn_more")}
                              </a>
                            </span>
                          </label>
                          <Select className="global-dropdown-select" classNamePrefix='cw'
                            name="Role"
                            aria-label="Role"
                            placeholder="Role"
                            options={userRole}
                            required
                            onChange={(value) => {
                              updateUserRole(value);
                            }}
                            value={userRole.filter(function (role) {
                              return role.value === selectedUserRole.value;
                            })}
                          ></Select>

                        </div>
                        {showAdditionalRoleDropdown && (
                          <div className="global-dropdown-block flex-center">
                            <label  htmlFor="another-role">
                              Add another role <span>Optional</span>
                            </label>

                            <Select className="global-dropdown-select" classNamePrefix='cw'                        placeholder="None"
                              id='another-role'
                              title='another-role'
                              aria-label="add another role optional"
                              options={additionalUserRole}
                              onChange={(value) => {
                                handleAdditionalRoleChange(value);
                              }}
                              value={additionalUserRole.filter(function (role) {
                                return (
                                  role.value ===
                                  selectedAdditionalUserRole.value
                                );
                              })}
                            ></Select>
                          </div>
                        )}
                      </div>
                    </div>

                    {departmentsAvailable && <div className="profile-department">
                      <h5 className="heading-width-border">
                        Department
                 
                        <p className="mb-0 ml-6 flex gb-focus"
                          data-padding="10px 10px 10px 10px"
                          data-place="right"
                          data-tip={Constants.NEW_USER_DEPARTMENTS_TOOLTIP}
                          data-for="user-management-department"
                          tabIndex={0}
                          id='departmentTooltip'
				                	aria-label='tooltip'
                          aria-expanded="false"
                        >
                          <svg
                            className="svg-tooltip-icon"
                            viewBox="0 0 1024 1024"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                           
                          >
                            <path d="M512 81.408a422.4 422.4 0 1 0 422.4 422.4A422.4 422.4 0 0 0 512 81.408z m26.624 629.76a45.056 45.056 0 0 1-31.232 12.288 42.496 42.496 0 0 1-31.232-12.8 41.984 41.984 0 0 1-12.8-30.72 39.424 39.424 0 0 1 12.8-30.72 42.496 42.496 0 0 1 31.232-12.288 43.008 43.008 0 0 1 31.744 12.288 39.424 39.424 0 0 1 12.8 30.72 43.008 43.008 0 0 1-13.312 31.744z m87.04-235.52a617.472 617.472 0 0 1-51.2 47.104 93.184 93.184 0 0 0-25.088 31.232 80.896 80.896 0 0 0-9.728 39.936v10.24h-64v-10.24a119.808 119.808 0 0 1 12.288-57.344A311.296 311.296 0 0 1 555.52 460.8l10.24-11.264a71.168 71.168 0 0 0 16.896-44.032A69.632 69.632 0 0 0 563.2 358.4a69.632 69.632 0 0 0-51.2-17.92 67.072 67.072 0 0 0-58.88 26.112 102.4 102.4 0 0 0-16.384 61.44h-61.44a140.288 140.288 0 0 1 37.888-102.4 140.8 140.8 0 0 1 104.96-38.4 135.68 135.68 0 0 1 96.256 29.184 108.032 108.032 0 0 1 36.352 86.528 116.736 116.736 0 0 1-25.088 73.216z" />
                          </svg>
                          <div className="font-zero">{Constants.NEW_USER_DEPARTMENTS_TOOLTIP}</div>
                        </p>
                        <ReactTooltip
                          className="tooltip"
                          id="user-management-department"
                          role='tooltip'
					                ref={departmentTooltipRef}
                        ></ReactTooltip>
                        <div className={ "error upload-error mb-0" + (userGroupMembersError === true ? " show" : " hide")}>
                          {userGroupMembersErrorMessage}
                        </div>
                      </h5>
                      {showDepartmentDropdown && (
                        <div className="global-dropdown-block flex-center">
                        <Select className="global-dropdown-select" classNamePrefix='cw'
                          name="Department"
                          aria-label="Department"
                          placeholder="Select department"
                          options={filteredDepartments}
                          onChange={(value) => updateSelectedDepartment(value)}
                          value={{
                            label: `${t('select_one_department')}`,
                            value: Constants.BLANK,
                          }}
                        ></Select></div>
                      )}
                      {!showDepartments && !showAdminDepartments && (
                        <p>
                          This user has not been assigned to any department.
                        </p>
                      )}
                      {showDepartments && (
                        <div className="table-responsive global-table ">
                        <table className="sortable" aria-label="Departments">
                          <tr>
                            <th aria-hidden="true"></th>
                            
                            {availableAsProjectFollower && <th><a aria-label="Available as project follower" onClick={handleAvailableAsProjectFollower} onKeyDown={handleAvailableAsProjectFollower} tabIndex={0}>{translate("user_management.available_as_project_follower")}</a></th>}
                            {automaticallyFollowProjects && <th><a aria-label="Automatically follow projects" onClick={handleAutomaticallyFollowProjects} onKeyDown={handleAutomaticallyFollowProjects} tabIndex={0}>{translate("user_management.automatically_follow_projects")}</a></th>}

                            {availableAsInternalTranslator && (
                              <th>
                                <a aria-label="Available as internal translator" onClick={handleAvailableAsInternalTranslator} onKeyDown={handleAvailableAsInternalTranslator} tabIndex={0}>Available as internal translator</a>
                              </th>
                            )}
                          </tr>
                          {departments.map((department) => {
                            return (
                              <tr>
                                <td>{getDepartmentIcon(department)}</td>
                                {availableAsProjectFollower && <td>
                                  <div className="form-check small-checkbox">
                                  <input
                                    style={{cursor : 'pointer'}}
                                    className="form-check-input"
                                    type="checkbox"
                                    name="checkbox"
                                    id={department.value+"-available-as-project-follower"}
                                    defaultChecked={(selectedUserRole?.value === Constants.ROLE_PROJECT_REQUESTER && selectedAdditionalUserRole?.value === Constants.BLANK) ? false : true}
                                    onChange={(e) => handleDepartmentChecks(e, department.value)}
                                  />
                                  <label for={department.value+"-available-as-project-follower"}></label>
                                  </div>
                                </td>}
                                {automaticallyFollowProjects && <td>
                                <div className="form-check small-checkbox">
                                  <input
                                    style={{cursor : 'pointer'}}
                                    className="form-check-input"
                                    type="checkbox"
                                    name="checkbox"
                                    id={department.value+"-automatically-follow-projects"}
                                    onChange={(e) => handleDepartmentChecks(e, department.value)}
                                  />
                                  <label for={department.value+"-automatically-follow-projects"}></label>
                                  </div>
                                </td>}
                                {availableAsInternalTranslator && (
                                  <td>
                                    <div className="form-check small-checkbox">
                                    <input
                                      style={{cursor : 'pointer'}}
                                      className="form-check-input"
                                      type="checkbox"
                                      name="checkbox"
                                      id={department.value+"-available-as-internal-translator"}
                                      onChange={(e) => handleDepartmentChecks(e, department.value)}
                                    />
                                    <label for={department.value+"-available-as-internal-translator"}></label>
                                    </div>
                                  </td>
                                )}
                              </tr>
                            )
                          })}
                        </table>
                      </div>
                      )}
                      {showAdminDepartments && (
                        <div className="table-responsive global-table ">
                        <table className="sortable" aria-label="Departments">
                          <tr>
                            <th aria-hidden="true"></th>
                            <th><a aria-label="Available as project follower" onClick={handleAvailableAsProjectFollower}tabIndex={0} onKeyDown={handleAvailableAsProjectFollower}>Available as project follower</a></th>
                            <th><a aria-label="Automatically follow projects" onClick={handleAutomaticallyFollowProjects}tabIndex={0} onKeyDown={handleAutomaticallyFollowProjects}>Automatically follow projects</a></th>
                            {availableAsInternalTranslator && (
                              <th>
                                <a aria-label="Available as internal translator" onClick={handleAvailableAsInternalTranslator} tabIndex={0} onKeyDown={handleAvailableAsInternalTranslator}>Available as internal translator</a>
                              </th>
                            )}
                          </tr>
                          {departmentsForAdministrator.map((adminDepartment) => {
                            return (
                              <tr>
                                <td>{getDepartmentIcon(adminDepartment)}</td>
                                <td>
                                <div className="form-check small-checkbox">
                                  <input
                                    style={{cursor : 'pointer'}}
                                    className="form-check-input"
                                    type="checkbox"
                                    name="checkbox"
                                    id={adminDepartment.value+"-available-as-project-follower"}
                                    defaultChecked
                                    onChange={(e) => handleDepartmentChecks(e, adminDepartment.value)}
                                  />
                                  <label for={adminDepartment.value+"-available-as-project-follower"}></label>
                                  </div>
                                </td>
                                <td>
                                <div className="form-check small-checkbox">
                                  <input
                                    style={{cursor : 'pointer'}}
                                    className="form-check-input"
                                    type="checkbox"
                                    name="checkbox"
                                    id={adminDepartment.value+"-automatically-follow-projects"}
                                    onChange={(e) => handleDepartmentChecks(e, adminDepartment.value)}
                                    
                                  />
                                  <label for={adminDepartment.value+"-automatically-follow-projects"}></label>
                                  </div>
                                </td>
                                {availableAsInternalTranslator && (
                                  <td>
                                    <div className="form-check small-checkbox">
                                    <input
                                      style={{cursor : 'pointer'}}
                                      className="form-check-input"
                                      type="checkbox"
                                      name="checkbox"
                                      id={adminDepartment.value+"-available-as-internal-translator"}
                                      onChange={(e) => handleDepartmentChecks(e, adminDepartment.value)}
                                    />
                                    <label for={adminDepartment.value+"-available-as-internal-translator"}></label>
                                    </div>
                                  </td>
                                )}
                              </tr>
                            )
                          })}
                        </table>
                      </div>
                      )}
                    </div>}
                    {showFollowOptions && !departmentsAvailable && <div className="profile-department">
                      <h5 className="heading-width-border">
                        Project Followers
                      </h5>
                      <p>What does following mean? A user receives email notifications for all projects they follow and can see followed projects' activity on their home page.</p>
                      {userGroupMemberSettings.length !== 0 ? <div className="table-responsive global-table ">
                        <table className="sortable" aria-label="Departments">
                          <tr>
                            <th aria-hidden="true"></th>
                            <th><a aria-label="Available as project follower" tabIndex={0} onKeyDown={handleAvailableAsProjectFollower}>Available as project follower</a></th>
                            <th><a aria-label="Automatically follow projects" tabIndex={0} onKeyDown={handleAutomaticallyFollowProjects}>Automatically follow projects</a></th>
                          </tr>
                          <tr>
                              <td aria-hidden="true"></td>
                              <td>
                              <div className="form-check small-checkbox">
                                <input
                                  style={{cursor : 'pointer'}}
                                  className="form-check-input"
                                  type="checkbox"
                                  name="checkbox"
                                  id={"system-user-available-as-project-follower"}
                                  defaultChecked
                                  onChange={(e) => handleDepartmentChecks(e, departments[0]?.value)}
                                />
                                <label for={"system-user-available-as-project-follower"}></label>
                                </div>
                              </td>
                              <td>
                              <div className="form-check small-checkbox">
                                <input
                                  style={{cursor : 'pointer'}}
                                  className="form-check-input"
                                  type="checkbox"
                                  name="checkbox"
                                  id={"system-user-automatically-follow-projects"}
                                  onChange={(e) => handleDepartmentChecks(e, departments[0]?.value)}
                                  
                                />
                                <label for={"system-user-automatically-follow-projects"}></label>
                                </div>
                              </td>
                            </tr>
                        </table>
                      </div> : <p>This user has not been assigned to any department.</p>}
                    </div>}
                  </div>
                  {showLanguagesToReview && (
                    <div className="lang-and-review">
                      <h5 className="heading-width-border">
                        Languages to Review
                      </h5>
                      <div className="form-check small-checkbox">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="updateExistingProjects"
                          id="updateExistingProjectsCheckbox"
                          checked={updateExistingProjects}
                          onChange={(e) => setUpdateExistingProjects(e.target.checked)}
                        />
                        <label className="form-check-label" htmlFor="updateExistingProjectsCheckbox">
                        {translate("user_management.campaigns_open_projects")}  </label>
                        <small>
                          Select the languages this user can review and will be
                          associated with. Language review tasks on a project
                          will include users who are following that project and
                          are associated to the language delivered by the
                          vendor.
                          <a
                            href="https://cloudwords.zendesk.com/hc/en-us/articles/206359323-Associating-Users-With-Languages-and-Receiving-Notifications"
                            target="_blank"
                          >
                            Learn more
                          </a>
                        </small>
                      </div>
                      <div className="flex wrap-dropdown">
                        <div className="global-dropdown-block flex-center">
                          <div className="global-dropdown-select">
                            <Select classNamePrefix='cw'
                              name="Language"
                              aria-label="Language"
                              placeholder="Language"
                              options={targetLanguage}
                              onChange={(value) => updateTargetLang(value)}
                              value={{
                                label: `${t('select_language')}`,
                                value: Constants.BLANK,
                              }}
                            ></Select>
                          </div>
                        </div>
                      </div>
                      <div className="multiselect-output flex">
                        {selectedTargetLanguageList &&
                          selectedTargetLanguageList.map((targetLanguage) => (
                            <button
                              onClick={(e) =>
                                clearTargetLanguage(targetLanguage)
                              }
                              onKeyDown={(e) =>
                                clearTargetLanguageOnKeydown(targetLanguage)
                              }
                            >
                              <strong>{targetLanguage.label}</strong>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="10"
                                height="9"
                                viewBox="0 0 10 9"
                                fill="none"
                              >
                                <path
                                  d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067"
                                  stroke="#213248"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                ></path>
                              </svg>
                            </button>
                          ))}
                      </div>
                    </div>
                  )}

                  {showLanguagePairs && 
                    <div className="role-and-department block-credential mt-5">
                      <h5 className="heading-width-border">
                        Language Pairs to Translate
                      </h5>
                      <div className="flex wrap-dropdown">
                      <div className="global-dropdown-block flex-center">
                        <label>
                          Add new source language
                        </label>
                        <Select
                              className="global-dropdown-select"
                              classNamePrefix='cw'
                              role="listbox"
                              aria-label="Source Language"
                              placeholder="Source Language"
                              options={sourceLanguage}
                              onChange={(value) => updateSourceLanguageAndToggleTargetDropdown(value)}
                              value={{
                                label: "--Select One--",
                                value: Constants.BLANK,
                              }}
                              filterOption={(option, filter) => option.data?.disabled !== true && (!filter || option.label.toLowerCase().indexOf(filter.toLowerCase()) > -1)}
                            />
                      </div>
                      </div>
                      <div className="multiselect-output flex mar-bot16 langs">
                        <ul className="conditional-fronm-to">
                          {displayUserLanguagePairs?.map((languagePair, index) => {
                            return (
                              <div key={index}>
                            <li className="flex mar-bot16">
                              <span>
                                From
                              </span>{" "}
                              <button onClick={() => removeLanguagePairSource(languagePair)}>
                                <strong>{languagePair.source.label}</strong>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="10"
                                  height="9"
                                  viewBox="0 0 10 9"
                                  fill="none"
                                >
                                  <path
                                    d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067"
                                    stroke="#213248"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  ></path>
                                </svg>
                              </button>{" "}
                              <span>
                                To
                              </span>{" "}
                              {"  "}
                              {languagePair.target?.map((targetLang, indx) => {
                                return (
                                  <button key={indx} onClick={() => removeLanguagePairTarget(languagePair, targetLang)}>
                                  <strong>{targetLang}</strong>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="10"
                                    height="9"
                                    viewBox="0 0 10 9"
                                    fill="none"
                                  >
                                    <path
                                      d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067"
                                      stroke="#213248"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    ></path>
                                  </svg>
                                  </button>
                                )
                              })}

                        <div className="global-dropdown-block m-0 new-user-internal">
                          
                                 <span
                                  className="blue-btn m-0"
                                  onClick={() => showTargetAssigneeListAndClearSelection(index, languagePair)}
                                >
                                  Add new target language
                                </span>
                            <Select
                              openMenuOnFocus={true}
                              ref={selectRef}
                              className="global-dropdown-select m-0"
                              classNamePrefix='cw'
                              role="listbox"
                              aria-label="Target Language"
                              placeholder="Target Language"
                              options={targetLanguageForPairing}
                              onChange={(value) => setTargetLanguageForSource(value, languagePair.source.displayLang)}
                              value={{
                                label: "Add new target language",
                                value: Constants.BLANK,
                              }}
                          />
                        </div>
                              
                            </li>
                          </div>
                            )
                          })}
                        </ul>
                      </div>
                    </div>
                  }

                  <div className="inner-permissions-tab">
                    {showRequestingBids && <div className="permission-list">
                      <h5>{translate("user_management.requesting_quotes")}</h5>
                      {features.AUTO_APPROVE_BID &&
                      <div className="form-check small-checkbox">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="permissions.BID_AUTO_APPROVAL"
                          id="permissions.BID_AUTO_APPROVAL"
                          checked={bidAutoApprove}
                          onChange={(e) => setBidAutoApprove(e.target.checked)}
                        />
                        <label className="form-check-label" htmlFor="permissions.BID_AUTO_APPROVAL">
                          Quote Auto-Approval: Can choose to automatically approve
                          a quote from a preferred vendor.
                        </label>
                      </div>}
                      {features.ALTER_TM_UPLOAD_REQUIREMENT && 
                      <div className="form-check small-checkbox">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="permissions.SKIP_PROJECT_TM_UPLOAD"
                          id="permissions.SKIP_PROJECT_TM_UPLOAD"
                          checked={skipTmUpload}
                          onChange={(e) => setSkipTmUpload(e.target.checked)}
                        />
                        <label className="form-check-label" htmlFor="permissions.SKIP_PROJECT_TM_UPLOAD">
                          Skip Translation Memory Upload: Can alter a project so
                          the vendor is not required to upload Translation
                          Memory.
                        </label>
                      </div>}
                    </div>}
                    {/* {!features.WHITE_LABEL_VENDOR_EXCLUSIVE && showVendorMarketplace && <div className="permission-list">
                      <h5>Vendor Marketplace</h5>
                      <div className="form-check small-checkbox">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="permissions.SEE_DIRECTORY_TAB"
                          id="permissions.SEE_DIRECTORY_TAB"
                          disabled={false}
                          checked={seeDirectoryTab}
                          onChange={(e) => setSeeDirectoryTab(e.target.checked)}
                        />
                        <label className="form-check-label" htmlFor="permissions.SEE_DIRECTORY_TAB">
                          Can view the vendor marketplace
                        </label>
                      </div>
                      <div className="form-check small-checkbox">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="permissions.BID_OUT_TO_CW_CHOSEN_VENDORS"
                          id="permissions.BID_OUT_TO_CW_CHOSEN_VENDORS"
                          disabled={false}
                          checked={bidOutToCloudwordsChosenVendors}
                          onChange={(e) => setBidOutToCloudwordsChosenVendors(e.target.checked)}
                        />
                        <label className="form-check-label" htmlFor="permissions.BID_OUT_TO_CW_CHOSEN_VENDORS">
                          Can request quotes for projects from vendors other
                          than preferred vendors
                        </label>
                      </div>
                    </div>} */}
                    {features.TM_BROWSE_AND_EDIT && <div className="permission-list">
                      <h5>{translate("user_management.tm")}</h5>
                      <div className="form-check small-checkbox">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="permissions.TM_READ_EDIT"
                          id="permissions.TM_READ_EDIT"
                          disabled={false}
                          checked={tmReadEdit}
                          onChange={(e) => setTmReadEdit(e.target.checked)}
                        />
                        <label className="form-check-label" htmlFor="permissions.TM_READ_EDIT">
                          Can access the Company and any Department Translation
                          Memory, including the ability to edit and delete
                          segments in any language pair
                        </label>
                      </div>
                    </div>}
                    <div className="permission-list">
                      <h5>{translate("user_management.access_to_glossary")}</h5>
                      <div className="form-check small-checkbox">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="permissions.GLOSSARY_READ"
                          id="permissions.GLOSSARY_READ"
                          disabled={false}
                          checked={glossaryRead}
                          onChange={(e) => setGlossaryRead(e.target.checked)}
                        />
                        <label className="form-check-label" htmlFor="permissions.GLOSSARY_READ">
                          Can view company and department glossaries
                        </label>
                      </div>
                      <div className="form-check small-checkbox">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="permissions.GLOSSARY_EDIT"
                          id="permissions.GLOSSARY_EDIT"
                          disabled={false}
                          checked={glossaryEdit}
                          onChange={(e) => setGlossaryEdit(e.target.checked)}
                        />
                        <label className="form-check-label" htmlFor="permissions.GLOSSARY_EDIT">
                        {translate("user_management.department_glossaries")}                         </label>
                      </div>
                    </div>
                    <div className="permission-list">
                      <h5>{translate("user_management.access_to_style_guide")}</h5>
                      <div className="form-check small-checkbox">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="permissions.STYLEGUIDE_READ_EDIT"
                          id="permissions.STYLEGUIDE_READ_EDIT"
                          disabled={false}
                          checked={styleguideReadEdit}
                          onChange={(e) => setStyleguideReadEdit(e.target.checked)}
                        />
                        <label className="form-check-label" htmlFor="permissions.STYLEGUIDE_READ_EDIT">
                        {translate("user_management.view_style_guide")}                         </label>
                      </div>
                    </div>
                    {features?.MARKETO_INTEGRATION && marketoEnabled.status === "true" && showMarketo && 
                    (
                      <div className="permission-list">
                        <h5>Access to Marketo</h5>
                        <div className="form-check small-checkbox">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="permissions.MARKETO_ACCESS"
                            id="permissions.MARKETO_ACCESS"
                            checked={marketo}
                            onChange={(e) => setMarketo(e.target.checked)}
                          />
                          <label className="form-check-label" htmlFor="permissions.MARKETO_ACCESS">
                            Has ability to create Marketo integration projects
                          </label>
                        </div>
                      </div>
                    )}
                    {features?.MARKETOREST_INTEGRATION && marketoRestEnabled.status === "true" && showMarketoRest && 
                    (
                      <div className="permission-list">
                        <h5>Access to MarketoRest</h5>
                        <div className="form-check small-checkbox">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="permissions.MARKETOREST_ACCESS"
                            id="permissions.MARKETOREST_ACCESS"
                            checked={marketoRest}
                            onChange={(e) => setMarketoRest(e.target.checked)}
                          />
                          <label className="form-check-label" htmlFor="permissions.MARKETOREST_ACCESS">
                            Has ability to create Marketo Rest integration projects
                          </label>
                        </div>
                      </div>
                    )}
                    {features?.BRIGHTCOVE_INTEGRATION && brightcoveEnabled?.status === "true" && showBrightcove && 
                    (
                      <div className="permission-list">
                        <h5>Access to Brightcove</h5>
                        <div className="form-check small-checkbox">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="permissions.BRIGHTCOVE_ACCESS"
                            id="permissions.BRIGHTCOVE_ACCESS"
                            checked={brightcove}
                            onChange={(e) => setBrightcove(e.target.checked)}
                          />
                          <label className="form-check-label" htmlFor="permissions.BRIGHTCOVE_ACCESS">
                            Has ability to create Brightcove integration projects
                          </label>
                        </div>
                      </div>
                    )}
                    {features?.PARDOT_INTEGRATION && pardotEnabled?.status === "true" && showPardot && 
                    (
                      <div className="permission-list">
                        <h5>Access to Pardot</h5>
                        <div className="form-check small-checkbox">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="permissions.PARDOT_ACCESS"
                            id="permissions.PARDOT_ACCESS"
                            checked={pardot}
                            onChange={(e) => setPardot(e.target.checked)}
                          />
                          <label className="form-check-label" htmlFor="permissions.PARDOT_ACCESS">
                            Has ability to create Pardot integration projects
                          </label>
                        </div>
                      </div>
                    )}
                    {features?.VIDYARD_INTEGRATION && vidyardEnabled?.status === "true" && showVidyard && 
                    (
                      <div className="permission-list">
                        <h5>Access to Vidyard</h5>
                        <div className="form-check small-checkbox">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="permissions.VIDYARD_ACCESS"
                            id="permissions.VIDYARD_ACCESS"
                            checked={vidyard}
                            onChange={(e) => setVidyard(e.target.checked)}
                          />
                          <label className="form-check-label" htmlFor="permissions.VIDYARD_ACCESS">
                            Has ability to create Vidyard integration projects
                          </label>
                        </div>
                      </div>
                    )}
                    {features?.UBERFLIP_INTEGRATION && uberflipEnabled?.status === "true" && showUberflip && 
                    (
                      <div className="permission-list">
                        <h5>Access to Uberflip</h5>
                        <div className="form-check small-checkbox">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="permissions.UBERFLIP_ACCESS"
                            id="permissions.UBERFLIP_ACCESS"
                            checked={uberflip}
                            onChange={(e) => setUberflip(e.target.checked)}
                          />
                          <label className="form-check-label" htmlFor="permissions.UBERFLIP_ACCESS">
                            Has ability to create Uberflip integration projects
                          </label>
                        </div>
                      </div>
                    )}
                    {features?.ELOQUA_INTEGRATION && eloquaEnabled?.status === "true" && showEloqua && 
                    (
                      <div className="permission-list">
                        <h5>Access to Eloqua</h5>
                        <div className="form-check small-checkbox">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="permissions.ELOQUA_ACCESS"
                            id="permissions.ELOQUA_ACCESS"
                            disabled={false}
                            checked={eloqua}
                            onChange={(e) => setEloqua(e.target.checked)}
                          />
                          <label className="form-check-label" htmlFor="permissions.ELOQUA_ACCESS">
                            Has ability to create Eloqua integration projects
                          </label>
                        </div>
                      </div>
                    )}
                    {features?.MACHINE_TRANSLATION && machineTranslationEnabled?.status === "true" && showMachineTranslation && 
                    (
                      <div className="permission-list">
                        <h5>Access to Machine Translation</h5>
                        <div className="form-check small-checkbox">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="permissions.MACHINE_TRANSLATION_ACCESS"
                            id="permissions.MACHINE_TRANSLATION_ACCESS"
                            disabled={false}
                            checked={machineTranslation}
                            onChange={(e) => setMachineTranslation(e.target.checked)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="permissions.MACHINE_TRANSLATION_ACCESS"
                          >
                            Has ability to create machine translation projects
                          </label>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div className="stricy-btn flex flex-center no-rightlist justify-end">
        <div className="left flex">
          <div>
            <button className="btn-default" aria-label="Cancel" onClick={cancelUserCreation} onKeyDown={(e) => cancelUserCreationOnKeyDown(e)}>Cancel</button>
          </div>
          <div>
            <button disabled={disableSaveButton} className={disableSaveButton ? "btn-default disabled-icon" : "btn-default"} aria-label="Save" onClick={createUser} onKeyDown={(e) => createUserOnKeyDown(e)}>Save</button>
          </div>
        </div>
      </div>
    </div>
  );
}
